<script lang="ts">
    import Menu from "./MenuBar.svelte";
    import Panel from "./Panel.svelte";
    import {Modal} from 'svelma';
    import Manager from "../application/models/Manager.ts";
    import Filter from "../application/models/Filter.ts";
    import {writable} from "svelte/store";
    import FooterElement from "../presentationals/FooterElement.svelte";
    import ModalController from "./ModalController.svelte";
    import SettingsManager from "../application/managers/SettingsManager.ts";
    import Settings from "../application/models/settings/Settings";
    import PhonePanel from "./PhonePanel.svelte";

    export let data;
    export let languages;

    let filter = writable(new Filter());
    let manager: Manager;
    if (data !== undefined) {
        $: manager = new Manager(data);
    }
    let modalActive: boolean = false;
    let modalDetail = writable({});

    function toggleModal(event) {
        $modalDetail = event.detail;
        if (!modalActive) modalActive = !modalActive;
    }
</script>

{#if data!==undefined}
    <Menu languages={languages} manager={manager} filter={filter}/>
    <Panel on:modalOpen={toggleModal} manager={manager} filter={filter}/>
    <PhonePanel on:modalOpen={toggleModal}  manager={manager} filter={filter}/>
    <FooterElement/>
    <Modal bind:active={modalActive}>
        <ModalController on:modalOpen={toggleModal} details={modalDetail} manager={manager}/>
    </Modal>
{/if}